import React, { useState } from "react";
import "./EventBookingCard.css";
import { FaStar } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { MdConfirmationNumber } from "react-icons/md";
import { TbTicket } from "react-icons/tb";
import { LuPartyPopper } from "react-icons/lu";
import { MdOutlineDone } from "react-icons/md";
import { IoCopyOutline } from "react-icons/io5";
import { LuQrCode } from "react-icons/lu";
import { FaDirections } from "react-icons/fa";
import { API_BASE_URL, openInGoogleMaps } from "../../utils";
import { useNavigate } from "react-router-dom";

const url = `${API_BASE_URL}/master/assets/uploads/`;


export default function EventBookingCard({ booking, isCompleted }) {

    const navigate = useNavigate();
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyOrderId = () => {
        navigator.clipboard.writeText(booking?.order_id);
        setIsCopied(true);
        // Reset copied state after 2 sec
        setTimeout(() => setIsCopied(false), 2000);
    }
    const handleNavigateToReview = () => {
        navigate(`/my-bookings/review/${booking?.club_id}?type=event&order_id=${booking?.order_id}`);
    };

    return (
        <div className="event-booking-card">
            {/* Left Image */}
            <div className="event-booking-img">
                <img src={url + booking.event_img} alt={booking.event_name} />
            </div>

            {/* Right Content */}
            <div className="event-booking-content">
                {/* Top Row */}

                {/* Title & Category */}
                <div className="event-booking-info">
                    <span className={`${isCopied ? "event-booking-order-copy" : "event-booking-order"} `}>
                        Order Id - {booking?.order_id}

                        <IoCopyOutline className={`copy-icon ${isCopied ? "copy-icon-copied" : ""}`} onClick={handleCopyOrderId} />

                    </span>

                    <div className="event-booking-title">
                        <h2>{booking?.event_name}</h2>
                    </div>

                    {/* Artist */}
                    {/* <p className="event-booking-artist">{booking.artist} ❤️</p> */}

                    {/* Club + Rating */}
                    <div className="event-booking-club">
                        <span>
                            <span className="event-booking-club-logo">
                                <img src={url + booking?.club_img} alt="club-logo" />
                            </span>
                            {booking?.club_name}
                        </span>

                        {booking?.rating?.stars
                            ? (
                                <>
                                    {(booking.rating.stars.split(",").map(Number).reduce((a, b) => a + b, 0) /
                                        booking.rating.stars.split(",").length).toFixed(1)}
                                    {" "}<FaStar className="event-star" /> | Review: "{booking.rating.msg}"
                                </>
                            )
                            : ""}
                    </div>

                    {/* Address + Distance */}
                    <p className="event-booking-address">
                        <IoLocationOutline /> {booking?.address?.length > 24 ? booking?.address?.slice(0, 24) + "..." : booking?.address}
                        <div className='event-new-card-text-section-location-distance' onClick={() => openInGoogleMaps(booking?.clubAddress)}>
                            <span>
                                <FaDirections />{" "}
                                {booking?.distance ? `${Math.round(Number(booking.distance))} Kms` : "--"}
                            </span>

                        </div>
                    </p>


                    {/* Event Type */}
                    <p className="event-booking-type">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M15.8335 6.24984C16.2937 6.24984 16.6668 5.87674 16.6668 5.4165C16.6668 4.95627 16.2937 4.58317 15.8335 4.58317C15.3733 4.58317 15.0002 4.95627 15.0002 5.4165C15.0002 5.87674 15.3733 6.24984 15.8335 6.24984Z" fill="#070707" />
                            <path d="M12.5002 6.24984C12.9604 6.24984 13.3335 5.87674 13.3335 5.4165C13.3335 4.95627 12.9604 4.58317 12.5002 4.58317C12.0399 4.58317 11.6668 4.95627 11.6668 5.4165C11.6668 5.87674 12.0399 6.24984 12.5002 6.24984Z" fill="#070707" />
                            <path d="M14.1585 7.49984C13.0085 7.49984 12.0752 8.19984 12.0752 9.0665H16.2418C16.2418 8.19984 15.3085 7.49984 14.1585 7.49984Z" fill="#070707" />
                            <path d="M0.833496 13.3332C0.833496 16.0915 3.07516 18.3332 5.8335 18.3332C8.59183 18.3332 10.8335 16.0915 10.8335 13.3332V7.49984H0.833496V13.3332ZM2.50016 9.1665H9.16683V13.3332C9.16683 15.1748 7.67516 16.6665 5.8335 16.6665C3.99183 16.6665 2.50016 15.1748 2.50016 13.3332V9.1665Z" fill="#070707" />
                            <path d="M9.16683 1.6665V6.24984H10.8335V3.33317H17.5002V7.49984C17.5002 9.3415 16.0085 10.8332 14.1668 10.8332C13.3752 10.8332 12.6585 10.5415 12.0835 10.0832V12.0415C12.7168 12.3332 13.4252 12.4998 14.1668 12.4998C16.9252 12.4998 19.1668 10.2582 19.1668 7.49984V1.6665H9.16683Z" fill="#070707" />
                            <path d="M4.16683 12.0832C4.62707 12.0832 5.00016 11.7101 5.00016 11.2498C5.00016 10.7896 4.62707 10.4165 4.16683 10.4165C3.70659 10.4165 3.3335 10.7896 3.3335 11.2498C3.3335 11.7101 3.70659 12.0832 4.16683 12.0832Z" fill="#070707" />
                            <path d="M7.50016 12.0832C7.9604 12.0832 8.3335 11.7101 8.3335 11.2498C8.3335 10.7896 7.9604 10.4165 7.50016 10.4165C7.03992 10.4165 6.66683 10.7896 6.66683 11.2498C6.66683 11.7101 7.03992 12.0832 7.50016 12.0832Z" fill="#070707" />
                            <path d="M5.8335 14.8998C6.9835 14.8998 7.91683 14.1998 7.91683 13.3332H3.75016C3.75016 14.1998 4.6835 14.8998 5.8335 14.8998Z" fill="#070707" />
                        </svg>
                        {booking?.category_type || "-"}</p>

                    {/* Date & Time */}
                    <div className="event-booking-datetime">
                        <div className="event-booking-date-time-wrap">
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
                                    <path d="M1.59375 5.03125C1.59375 3.99572 2.43322 3.15625 3.46875 3.15625H13.5313C14.5668 3.15625 15.4062 3.99572 15.4062 5.03125V14.0312C15.4062 15.0668 14.5668 15.9062 13.5312 15.9062H3.46875C2.43322 15.9062 1.59375 15.0668 1.59375 14.0312V5.03125Z" stroke="#4F4F4F" stroke-width="1.25" stroke-linejoin="round" />
                                    <circle cx="9.82812" cy="8.20312" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="12.4844" cy="8.20312" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="9.82812" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="12.4844" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="4.51562" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="7.17188" cy="10.8594" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="4.51562" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="7.17188" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                                    <circle cx="9.82812" cy="13.5156" r="0.796875" fill="#4F4F4F" />
                                    <path d="M4.25 2.09375V3.15625M12.75 2.09375V3.15625" stroke="#4F4F4F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M15.4062 5.8125H1.59375" stroke="#4F4F4F" stroke-width="1.25" stroke-linejoin="round" />
                                </svg> Date:</span>
                            <strong>
                                {booking?.party_date || "--/--/----"}
                            </strong>
                        </div>
                        <div className="event-booking-date-time-wrap">
                            <span><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <path d="M9 2.25C5.27344 2.25 2.25 5.27344 2.25 9C2.25 12.7266 5.27344 15.75 9 15.75C12.7266 15.75 15.75 12.7266 15.75 9C15.75 5.27344 12.7266 2.25 9 2.25Z" stroke="#4F4F4F" stroke-width="1.25" />
                                <path d="M9 4.5V9.5625H12.375" stroke="#4F4F4F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Time:</span>
                            <strong>
                                {booking?.party_time || "--:--"}
                            </strong>
                        </div>
                    </div>

                </div>

                <div className="event-booking-info-sec">


                    <div className="event-booking-top">
                        {!isCompleted && (
                            <span className="event-booking-status"><MdOutlineDone /> {booking?.status === "success" ? "Booking confirmed" : "Pending"}</span>
                        )}
                        {/* Actions */}
                        <div className="event-booking-actions-btn">
                            <button className="event-booking-view-btn"> <LuQrCode /> View Details</button>
                        </div>
                    </div>


                    {isCompleted ? (
                        <>
                            {booking?.rating && Object.keys(booking.rating).length > 0 ? (
                                <>
                                    <div>
                                        <h6>reviewed</h6>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="event-booking-write-review"><button onClick={handleNavigateToReview}>Write Review</button></div>
                                </>
                            )}
                        </>
                    ) : (
                        <div className="event-booking-bottom-sec-tickets">

                            <div className="event-booking-footer">
                                <span className="event-booking-tickets">
                                    <TbTicket size={20} /> Tickets{" "}
                                    {Number(booking?.event_info?.ticket_qty || 0)}
                                </span>

                            </div>

                            {/* Tickets + Amount */}
                            <div className="event-booking-footer">
                                <span className="event-booking-amount">Paid Amount: ₹{Number(booking.total_amount) > 0 ? Number(booking.total_amount) : 50}</span>
                            </div>
                        </div>
                    )}
                </div>


            </div>
        </div>
    );
}
